import { useState, useEffect } from 'react';
import { Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';

import TextArea from '../../form/TextArea';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

function Form({ token, dados, setDados, handleSubmit, btnText, caminhoVoltar, OptionsEmpresa }) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    function handleChange(e) {
        const { name, value, checked, type } = e.target;

        setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
    }

    async function handleOnBlur(e) {
        const { name, value, checked, type } = e.target;
        //verifica duplicidade
        if (name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'Situacoes', value);

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Situacao/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                    btnText: 'Atualizar',
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <Tabs>
            {' '}
            <form onSubmit={submit}>
                <h1>Situação</h1>
                <div>
                    <SelectEmpresa
                        text="Selecione a Empresa"
                        name="empresaId"
                        options={OptionsEmpresa}
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.empresaId || ''}
                        required
                        notOptNull={true}
                    />
                    <Input
                        text="Descrição"
                        type="text"
                        name="descricao"
                        placeholder="Situação"
                        title="Digite o nome do situação"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.descricao || ''}
                        required={true}
                    />
                    <Input
                        text="Código"
                        type="text"
                        name="codigo"
                        placeholder="código"
                        title="Código técnico da situação (ex: ORC, LOC, DEV)"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.codigo || ''}
                    />
                    <Input
                        text="Cor"
                        type="text"
                        name="cor"
                        placeholder="Cor"
                        title="Digite o código HEXDECIMAL da cor"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.cor || ''}
                    />
                    <Checkbox
                        title="Ativa quando marcado"
                        text="Ativo"
                        name="ativo"
                        handleOnChange={handleChange}
                        value={dados.ativo}
                        checked={!!dados.ativo}
                    />
                </div>
                <div>
                    {' '}
                    <TextArea
                        text="Título"
                        type="text"
                        name="titulo"
                        placeholder="Texto que auxilia o usuário a compreender o campo"
                        title="Digite o título"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.titulo || ''}
                        textAlign="left"
                        linhas="4"
                        //colunas="122"
                    />
                </div>
                <div>
                    <Checkbox
                        title="Modulo Almoxarifado"
                        text="Almoxarifado"
                        name="almoxarifado"
                        handleOnChange={handleChange}
                        value={dados.almoxarifado}
                        checked={!!dados.almoxarifado}
                    />
                    <Checkbox
                        title="Modulo Balanço"
                        text="Balanço"
                        name="balanco"
                        handleOnChange={handleChange}
                        value={dados.balanco}
                        checked={!!dados.balanco}
                    />
                    <Checkbox
                        title="Modulo Caixa"
                        text="Caixa"
                        name="caixa"
                        handleOnChange={handleChange}
                        value={dados.caixa}
                        checked={!!dados.caixa}
                    />
                    <Checkbox
                        title="Modulo Conferência"
                        text="Conferência"
                        name="conferencia"
                        handleOnChange={handleChange}
                        value={dados.conferencia}
                        checked={!!dados.conferencia}
                    />
                    <Checkbox
                        title="Modulo Financeiro"
                        text="Financeiro"
                        name="entrada"
                        handleOnChange={handleChange}
                        value={dados.financeiro}
                        checked={!!dados.financeiro}
                    />
                    <Checkbox
                        title="Movimentos de estoque"
                        text="Entrada"
                        name="entrada"
                        handleOnChange={handleChange}
                        value={dados.entrada}
                        checked={!!dados.entrada}
                    />
                    <Checkbox
                        title="Modulo Indústria"
                        text="Indústria"
                        name="industria"
                        handleOnChange={handleChange}
                        value={dados.industria}
                        checked={!!dados.industria}
                    />
                    <Checkbox
                        title="Define que a operação é utilizada no modulo de inventários"
                        text="Inventário"
                        name="inventario"
                        handleOnChange={handleChange}
                        value={dados.inventario}
                        checked={!!dados.inventario}
                    />
                    <Checkbox
                        title="Modulo Lançamentos Financeiros"
                        text="Lançamento"
                        name="lancamento"
                        handleOnChange={handleChange}
                        value={dados.lancamento}
                        checked={!!dados.lancamento}
                    />
                    <Checkbox
                        title="Modulo Locação"
                        text="Locação"
                        name="locacao"
                        handleOnChange={handleChange}
                        value={dados.locacao}
                        checked={!!dados.locacao}
                    />
                    <Checkbox
                        title="Modulo Logística"
                        text="Logística"
                        name="logistica"
                        handleOnChange={handleChange}
                        value={dados.logistica}
                        checked={!!dados.logistica}
                    />
                    <Checkbox
                        title="Modulo Manutenção"
                        text="Manutenção"
                        name="manutencao"
                        handleOnChange={handleChange}
                        value={dados.manutencao}
                        checked={!!dados.manutencao}
                    />
                    <Checkbox
                        title="Modulo Movimento"
                        text="Movimento"
                        name="movimento"
                        handleOnChange={handleChange}
                        value={dados.movimento}
                        checked={!!dados.movimento}
                    />
                    <Checkbox
                        title="Modulo Movimento Item"
                        text="Movimento Item"
                        name="movimentoItem"
                        handleOnChange={handleChange}
                        value={dados.movimentoItem}
                        checked={!!dados.movimentoItem}
                    />
                    <Checkbox
                        title="Movimentos de estoque"
                        text="Saída"
                        name="saida"
                        handleOnChange={handleChange}
                        value={dados.saida}
                        checked={!!dados.saida}
                    />
                    <Checkbox
                        title="Modulo Serviço"
                        text="Serviço"
                        name="servico"
                        handleOnChange={handleChange}
                        value={dados.servico}
                        checked={!!dados.servico}
                    />
                    <Checkbox
                        title="Modulo de requisição de produtos ou serviços, funciona para operações internas na empresa"
                        text="Requisição"
                        name="requisitante"
                        handleOnChange={handleChange}
                        value={dados.requisitante}
                        checked={!!dados.requisitante}
                    />
                </div>
                <h4>Homologação</h4>
                <div>
                    <Checkbox
                        title="Modulo Homologação"
                        text="Homologação"
                        name="homologation"
                        handleOnChange={handleChange}
                        value={dados.homologation}
                        checked={!!dados.homologation}
                    />
                    <Checkbox
                        title="Modulo Homologação"
                        text="Item"
                        name="homologationItem"
                        handleOnChange={handleChange}
                        value={dados.homologationItem}
                        checked={!!dados.homologationItem}
                    />
                    <Checkbox
                        title="Modulo Homologação"
                        text="Pessoa"
                        name="homologationPessoa"
                        handleOnChange={handleChange}
                        value={dados.homologationPessoa}
                        checked={!!dados.homologationPessoa}
                    />
                    <Checkbox
                        title="Modulo Homologação"
                        text="Registro"
                        name="homologationRegistro"
                        handleOnChange={handleChange}
                        value={dados.homologationRegistro}
                        checked={!!dados.homologationRegistro}
                    />
                </div>
                <div>
                    <Stack direction="row" spacing={1}>
                        <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                            Voltar
                        </Button>
                        <Button type="submit" variant="contained" color="success">
                            {btnText}
                        </Button>
                    </Stack>
                </div>
            </form>
        </Tabs>
    );
}
export default Form;
